import React from 'react';

import Emoji, { getAll } from '../components/Emoji';
import classes from '../constants/classes';
import { prefixCls } from '../utils/style';
import { I18n } from '@byted-cg/linkchat-plugin';

interface EmojiPanelProps {
  quickHidden?: boolean;
  onClick?: (key: string) => void;
  style?: React.CSSProperties;
  query?: Record<string, any>;
}
const orderEmoji = [
  19, 21, 8, 2, 6, 10, 17, 7, 5, 4, 18, 11, 15, 20, 38, 61, 44, 52, 54, 58, 1,
  22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 9, 39, 40, 41,
  42, 43, 3, 45, 46, 47, 48, 49, 50, 51, 83, 84, 85, 87, 86, 81, 90, 91, 82, 16,
  62, 63, 64, 65, 67, 94, 68, 69, 70, 71, 92, 80, 66, 79, 88, 89, 93, 13, 14,
  12, 95, 101, 53, 102, 96, 97, 98, 99, 100, 55, 56, 57, 59, 112, 60, 107, 108,
  109, 103, 72, 73, 74, 75, 76, 113, 78, 77, 114, 111, 110, 104, 105, 106,
];
const Emojis = getAll();

export const EmojiPanel: React.FC<EmojiPanelProps> = ({
  onClick,
  quickHidden,
  style = {},
  query = {},
}) => {
  const handleClick = (key: string) => {
    if (typeof onClick === 'function') {
      const keyName = key.replace(/\[(\S+?)\]/, '$1');
      onClick(`[${I18n.t(keyName, {}, keyName)}]`);
    }
  };
  return (
    <div
      className={prefixCls(
        {
          [`${classes.prefix}EmojiPanel`]: true,
          hasQuickBtnGroup: !quickHidden,
        },
        query.isPc,
      )}
      style={{ ...style }}
    >
      {orderEmoji.map((i) => {
        const index = i - 1;
        const emojiObj = Emojis[index];
        return (
          <div
            key={index}
            onClick={() => handleClick(emojiObj.key)}
            className="emojiItem"
          >
            <Emoji type={emojiObj.emoji} alt={emojiObj.key} />
          </div>
        );
      })}

      {/* Layout placeholder use */}
      {Array.from({ length: 30 }).map((i, index) => (
        <i key={`place-${index}`}></i>
      ))}
    </div>
  );
};

export default EmojiPanel;
